import {FC} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useAppSelector} from 'src/redux/hooks'
import {soSelector} from 'src/redux/slices/soSlices'

interface Props {}

export const SelectIDSubSO: FC<Props> = () => {
  const {orderItem} = useAppSelector(soSelector)

  if (!orderItem) return null

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>ID Sub SO</Form.Label>
      </Col>
      <Col md={8}>
        <Form.Select size='sm' aria-label='Default select example' disabled>
          <option selected>{orderItem?.id}</option>
        </Form.Select>
      </Col>
    </Row>
  )
}
